import Marquee from "react-fast-marquee";

const items = [
  "Enterprise SaaS",
  "Series-A Fintechs",
  "Healthtech",
  "D2C Brands",
  "AI Startups",
  "Global Recruiters",
  "Marketplaces",
  "Logistics OS",
  "Dev Tools",
  "Climate Tech",
];

export default function ClientsMarquee() {
  return (
    <section
      data-testid="clients-marquee"
      className="border-y fis-hairline bg-white py-6"
    >
      <div className="fis-marquee-mask">
        <Marquee speed={40} gradient={false}>
          {items.concat(items).map((t, i) => (
            <div
              key={i}
              className="flex items-center gap-6 px-8 font-mono-label text-sm"
            >
              <span className="text-[color:var(--fis-accent)]">●</span>
              <span className="tracking-[0.2em]">{t}</span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
